<template>
  <VaLayout style="background-color: white">
    <template #top>
      <AppNavbar />
    </template>

    <template #left>
      <div class="p-4 bg-[var(--va-background-element)] pr-6 h-screen">
        <div class="grid grid-cols-12 sm:grid-cols-12 gap-4 mt-8">
          <div
            class="px-6 py-4 flex col-span-12 gap-4 rounded-lg hover:bg-slate-200 text-primary cursor-pointer"
            :class="profileBg"
            @click="redirectTo('profile')"
          >
            <div><img src="@/assets/icons/userBlue.svg" width="20" height="20" alt="profile" /></div>
            <div class="text-md font-normal">Profile</div>
          </div>
          <div
            class="px-6 py-4 flex col-span-12 gap-4 rounded-lg hover:bg-slate-200 text-primary cursor-pointer"
            :class="alertsBg"
            @click="redirectTo('alerts')"
          >
            <div>
              <img src="@/assets/icons/blueBell.svg" width="20" height="20" alt="profile" />
            </div>
            <div class="text-md font-normal">Alerts</div>
          </div>
          <!-- <div class="px-6 py-4 flex col-span-12 gap-4 rounded-lg cursor-pointer" @click="redirectTo()">
            <div><img src="@/assets/icons/profile.svg" width="20" height="20" alt="profile" /></div>
            <div class="text-md font-bold">Account</div>
          </div> -->
          <!-- <div class="px-6 py-4 flex col-span-12 gap-4 border">
            <div><img src="@/assets/icons/user.svg" width="20" height="20" alt="profile" /></div>
            <div class="text-md font-bold">Profile</div>
          </div> -->
          <!-- <AppSidebar class="h-full" :minimized="isSidebarMinimized" :animated="!isMobile" :mobile="isMobile" /> -->
        </div>
      </div>
    </template>

    <template #content>
      <div :class="{ minimized: isSidebarMinimized }" class="app-layout__sidebar-wrapper">
        <div v-if="isFullScreenSidebar" class="flex justify-end">
          <VaButton class="px-4 py-4" icon="md_close" preset="plain" @click="onCloseSidebarButtonClick" />
        </div>
      </div>
      <AppLayoutNavigation v-if="!isMobile" class="p-4" />
      <main class="pt-0 pl-6">
        <!-- <Search /> -->
        <article>
          <RouterView />
        </article>
      </main>
    </template>

    <!-- <template #bottom>
      
    </template> -->
  </VaLayout>
  <Footer class="py-4" />
</template>
<script setup>
import AppNavbar from '../components/navbar/AppNavbar.vue'
// import AppSidebar from '../components/sidebar/AppSidebar.vue'
import Footer from '@/components/Footer.vue'
import { useRouter, useRoute } from 'vue-router'
import { onBeforeUnmount, onMounted, ref, computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { onBeforeRouteUpdate } from 'vue-router'
import { useBreakpoint } from 'vuestic-ui'
import { useAuthStore } from '../stores/authStore.js'
import { useGlobalStore } from '../stores/global-store'
import AppLayoutNavigation from '../components/app-layout-navigation/AppLayoutNavigation.vue'
import { useDomainStore } from '../stores/dashBoardStore'
// import Search  from '../components/Search.vue'

const GlobalStore = useGlobalStore()
const auth = useAuthStore()
const route = useRoute()
const currPath = ref(route.path)
const breakpoints = useBreakpoint()
const router = useRouter()
const sidebarWidth = ref('16rem')
const sidebarMinimizedWidth = ref(undefined)
const profileBg = ref('bg-slate-200')
const alertsBg = ref('bg-slate-200')
const isMobile = ref(false)
const isTablet = ref(false)
const { isSidebarMinimized } = storeToRefs(GlobalStore)
const pageStore = useDomainStore()
// const props = defineProps(['page'])

const onResize = () => {
  isSidebarMinimized.value = breakpoints.mdDown
  isMobile.value = breakpoints.smDown
  isTablet.value = breakpoints.mdDown
  sidebarMinimizedWidth.value = isMobile.value ? '0' : '4.5rem'
  sidebarWidth.value = isTablet.value ? '100%' : '16rem'
}

const checkPath = (val) => {
  if (val === 'profile') {
    profileBg.value = 'bg-slate-300'
    alertsBg.value = 'bg-slate-100'
  } else {
    profileBg.value = 'bg-slate-100'
    alertsBg.value = 'bg-slate-300'
  }
}

onMounted(() => {
  if (currPath.value.includes('profile')) {
    checkPath('profile')
  } else {
    checkPath('alerts')
  }
  window.addEventListener('resize', onResize)
  GlobalStore.setSideBar(true)
  if (auth.isLoggedIn === false) {
    // push({ name: 'login' })
    // window.location.href='/auth/login'
    router.push(currentPath.replace('/dashboard', '/auth/login'))
    window.location.href = '/auth/login'
  }
  onResize()
  // if (breakpoints.mdDown) {
  // Collapse sidebar after route change for Mobile
  isSidebarMinimized.value = true
  // }
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})

onBeforeRouteUpdate(() => {
  if (breakpoints.mdDown) {
    // Collapse sidebar after route change for Mobile
    isSidebarMinimized.value = true
  }
})

const isFullScreenSidebar = computed(() => isTablet.value && !isSidebarMinimized.value)

const redirectTo = (string) => {
  checkPath(string)
  router.push({ name: string })
}

const onCloseSidebarButtonClick = () => {
  isSidebarMinimized.value = false
}

watch(
  () => pageStore.accountPagePath,
  () => {
    checkPath(pageStore.accountPagePath)
  },
)
</script>

<style lang="scss" scoped>
// Prevent icon jump on animation
.va-sidebar {
  width: unset !important;
  min-width: unset !important;
}
.va-layout-area {
  display: block !important;
}
</style>
